import { useMutation } from "@apollo/client";

import { SUBCONTRACTOR_IMPORT_REIMPORT } from "graphql/mutation/subcontractor-gql";
import { GET_SUBCONTRACTORS } from "graphql/query/subcontractor-gql";

import { successNotification, errorNotification } from "components/request-result";


const useMutationSubcontractorImportReimport = ({ variables }) => {

    const [ _setImportReimport, { loading, data } ] = useMutation(SUBCONTRACTOR_IMPORT_REIMPORT,
        {
            update(cache, { data }) {

                const {
                    subcontractorImportOrReImport: {
                        label,
                        message,
                        //eslint-disable-next-line
                        sync_info
                    }
                } = data;


                successNotification({
                    title: label,
                    description: message
                })
            },

            onError(error) {
                errorNotification(error);
            },

            refetchQueries: [
                {
                    query: GET_SUBCONTRACTORS,
                    variables
                },
            ]
        }
    );


    return {
        _setImportReimport,
        dataMutationImportReimport: data,
        loadingMutationImportReimport: loading,
    }
};

export default useMutationSubcontractorImportReimport;

